const FracturedGraph = require('./fractured-graph/script');
const FragmentBackground = require('./polygon-background/script');
const GradientShape = require('./gradient-shape/script');
const Stat = require('./stat/script');
const TextSplitter = require('./text-splitter/script');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-fractured-graph]', function () {
		new FracturedGraph($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-gradient-shape]', function () {
		new GradientShape($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-split-text]', function () {
		// new TextSplitter($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-stat]', function () {
		new Stat($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-polygon-background]', function () {
		// window.RENGINE.add(new FragmentBackground(this));
	});

});
